import { GridProps } from './Grid.types'
import GridWrapper from './Grid.styles'

const Grid = ({ styles, children, ...props }: GridProps) => (
  <GridWrapper className="Grid" role="grid" sx={styles} {...props}>
    {children}
  </GridWrapper>
)

export default Grid
